/**
 * Prose overrides turning a markdown blockquote into a plain indent level:
 * no quote bar, no italics, no curly quotation marks, and no block margins of
 * its own - the blocks inside keep their own spacing. A quote document has no
 * quotations, only indentation, which markdown can store no other way.
 *
 * The first and last block inside lose their outer margins too. Prose zeroes
 * those only on its own direct children, so without this an indented line sits
 * a line lower than the same line unindented - indenting would appear to also
 * push the text down.
 *
 * Literal here, and applied wherever quote-document markdown renders, so the
 * Tailwind build-time scanner compiles the utilities and the editor surface,
 * the rendered document and the PDF all indent by the same amount.
 */
export const PROSE_INDENT_CLASS =
  "[&_blockquote]:my-0 [&_blockquote]:border-l-0 [&_blockquote]:pl-8 [&_blockquote]:font-normal [&_blockquote]:not-italic [&_blockquote>*:first-child]:mt-0 [&_blockquote>*:last-child]:mb-0 [&_blockquote_p:first-of-type]:before:content-none [&_blockquote_p:last-of-type]:after:content-none";
